import network from '@/utils/network'
import store from '@/store'
import { createRequestWithComputedFilters, customerPath } from '@/utils/api'

/**
 * Récupère les rondes de l'agence
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const fetchAgencyRondes = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}${customerPath()}/fetch/rounds`, params)
    return r.data
  },
  {
    filters: {
      site: 'all',
      customer: 'all'
    }
  })

/**
 * Permet de soumettre une ronde
 * @param round
 * @returns {Promise<>}
 */
export const postAgencyRound = async (round) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(
    `agency/${slugAgency}/round`,
    round)
  return r.data
}

/**
 * Permet de récupérer les infos d'exécution d'une ronde
 * @param id
 * @returns {Promise<>}
 */
export const getEventRound = async (id) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(
    `agency/${slugAgency}/service-round/${id}`)
  return r.data
}

/**
 * Transmet une event ronde (start / stop / finish)
 * @param location
 * @param event
 * @returns {Promise<*>}
 */
export const putRoundEvent = async ({ eventKey, serviceRoundExecution, event }) => {
  const slugAgency = store.getters['user/agencySlug']
  const serviceActif = store.getters['service/serviceActif'] || throw new Error('No active service')
  const r = await network.put(
    `agency/${slugAgency}/circuit/${serviceActif.id}/round/${eventKey}`,
    {
      serviceRoundExecution,
      event
    })
  return r.data
}
/**
 * Supprime une ronde
 * @param client
 * @param site
 * @param slug
 * @returns {Promise<>}
 */
export const deleteAgencyCustomerRound = async ({ client, site, slug }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`/agency/${slugAgency}/customer/${client}/site/${site}/round/${slug}`)
  return r.data
}

/**
 * Récupère l'export pdf d'une ronde
 * @returns {Promise<Array>}
 */
export const getRoundsPdf = async (id, params) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/service-round/${id}/pdf`, params)
  return r.data
}
